import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'auth_by_email.title',
  },
  subTitle: {
    id: 'auth_by_email.sub_title',
  },
  validationErrorMessage: {
    id: 'auth_by_sms.validation_error_message',
  },
  notYetReceived: {
    id: 'auth_by_email.not_yet_received',
  },
  proceedDifferently: {
    id: 'auth_by_sms.proceed_differently',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
